import { Stack, Typography } from "@mui/material";

const TableEmptyMessage = () => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={1}
      sx={{ py: 10, width: "100%" }}
    >
      <Typography variant="h6" sx={{ textAlign: "center" }}>
        Nothing found
      </Typography>
      <Typography variant="body2" sx={{ textAlign: "center" }}>
        No items found for applied filters
      </Typography>
    </Stack>
  );
};

export default TableEmptyMessage;
